export default __webpack_public_path__ + "static/media/myTeamCustomerSup.5a957551.png";